/**
 * Entry point principale per VibeTide Dashboard
 * Inizializza l'applicazione React con performance monitoring
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Importa variabili d'ambiente
import './config/env';

// Performance monitoring (opzionale in sviluppo)
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

// Cache buster: 2025-12-06-11
console.log('VibeTide Dashboard v2025-12-06-11');
window.VIBETIDE_VERSION = '2025-12-06-11';

// Funzione per inviare metriche (placeholder per futuro analytics)
function sendToAnalytics(metric) {
  if (process.env.NODE_ENV === 'production') {
    console.log('📊 Performance metric:', metric);
    // Qui si potrebbero inviare le metriche a un servizio di analytics
  }
}

// Misura Core Web Vitals se in produzione
if (process.env.NODE_ENV === 'production') {
  getCLS(sendToAnalytics);
  getFID(sendToAnalytics);
  getFCP(sendToAnalytics);
  getLCP(sendToAnalytics);
  getTTFB(sendToAnalytics);
}

// Inizializza l'applicazione
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Disabilita service worker in produzione per evitare problemi di cache/mismatch
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((reg) => reg.unregister()))
    .catch(() => { });
}
